<template>
    <Popover v-if="showTariffWarning">
        <PopoverTrigger class="flex items-stretch">
            <Badge variant="warning">
                <Icon name="globe" class="text-lg" />
                <span>{{ $t("Global.Tariff") }}</span>
            </Badge>
        </PopoverTrigger>
        <PopoverContent class="w-72" :align="'start'" hide-when-detached>
            <p class="text-lg font-bold">{{ $t("Global.Tariff") }}</p>
            <p class="text-sm">{{ $t("Global.TariffToolTip") }}</p>
        </PopoverContent>
    </Popover>
</template>
<script setup lang="ts">
const config = useStateGlobalConfig();
const {
    partDetail = null,
    result = null,
    responsePart = null,
} = defineProps<{
    partDetail?: PartDetail | null;
    result?: PartDetailResultTransformed | null;
    responsePart?: BOMSearchResponsePart | null;
}>();

const hasAnyTariff = (partResults?: PartResult[]) =>
    Array.isArray(partResults) && partResults.some((partResult) => partResult.IsAffectedByTariff);

const showTariffWarning = computed(() => {
    if (!config.value.ShowTariffWarning) {
        return false;
    } else if (partDetail) {
        return partDetail.IsAffectedByTariff || hasAnyTariff(partDetail.Results);
    } else if (result) {
        return result.IsAffectedByTariff || hasAnyTariff(result.PartResults);
    } else if (responsePart) {
        return responsePart.PartDetail?.IsAffectedByTariff || hasAnyTariff(responsePart.DistributorResults);
    } else {
        return false;
    }
});
</script>
